const fontSize = {
  xs: "0.75rem",
  tiny: "0.8rem",
  sm: "0.875rem",
  s: "0.934rem",
  base: "1rem",
  md: "1.07rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "4rem",
}

module.exports = {
  fontSize,
}

exports.default = fontSize
